/* eslint-disable */

export interface AccountForChildEligibilityDetails {
    child: PersonInfo;
    currentBankCreateShareSavingsAccountEligibility: CreateShareSavingsAccountEligibility;
    otherCustomerBanksCreateShareSavingsAccountEligibilities: CreateShareSavingsAccountEligibility[];
}

export interface ApplicantParent {
    email?: string;
    fnr: Foedselsnummer;
    name: string;
}

export interface ApproveCreateShareSavingsAccountForChildProcessPayload {
    approverParentEmail: string;
    id: string;
    sparingApplication: SparingApplication;
}

export interface ApproverParent {
    email?: string;
    fnr: Foedselsnummer;
    name: string;
    phoneNumber: string;
}

export interface Bank {
    bankregnr: Bankregnr;
    name: string;
}

export interface Bankregnr extends HarValue<string> {
    value: string;
}

export interface CompletionStage<T> {
}

export interface CreateShareSavingsAccountEligibility {
    allowedOperations: Operation[];
    applicantParent: PersonInfo;
    approverParent: PersonInfo;
    bank: Bank;
    ineligibilityReason?: IneligibilityDetails;
}

export interface CreateShareSavingsAccountForChildProcess {
    accessLevel: string;
    applicantParent: ApplicantParent;
    approverParent: ApproverParent;
    bankregnr: Bankregnr;
    child: PersonInfo;
    created: DateAsString;
    handoverAge: number;
    id: string;
    processStatus: ProcessStatus;
    updated: DateAsString;
}

export interface CreateShareSavingsAccountForChildProcessPayload {
    applicantParent: ApplicantParent;
    applicantParentHasGivenConsent: boolean;
    approverParent: ApproverParent;
    bankregnr: Bankregnr;
    child: PersonInfo;
    handoverAge?: number;
}

export interface CreateShareSavingsAccountForChildProcessRules {
    defaultHandoverAge: number;
    governorAmountThreshold: GovernorAmountThreshold;
    scholarshipAmountThreshold: ScholarshipAmountThreshold;
}

export interface ExistingProcess {
    processId: string;
    status: ProcessStatus;
}

export interface Foedselsnummer extends HarValue<string> {
    value: string;
}

export interface GovernorAmountThreshold {
    value: number;
    year: string;
}

export interface HarValue<T> {
    value: T;
}

export interface IneligibilityDetails {
    existingProcess?: ExistingProcess;
    reasonCode: IneligibilityReasonCode;
    reasonText: string;
}

export interface NameAndUrl {
    name: string;
    url: string;
}

export interface PersonInfo {
    fnr: Foedselsnummer;
    name: string;
}

export interface ScholarshipAmountThreshold {
    value: number;
    year: string;
}

export interface SessionModel {
    bankregnr: Bankregnr;
    cid: string;
    email?: string;
    firstName?: string;
    fnr: Foedselsnummer;
    lastName?: string;
    phone?: string;
}

export type DateAsString = string;

export enum IneligibilityReasonCode {
    PROCESS_ALREADY_EXISTS = "PROCESS_ALREADY_EXISTS",
    ACCOUNT_ALREADY_EXISTS = "ACCOUNT_ALREADY_EXISTS",
    UNKNOWN = "UNKNOWN",
}

export enum Operation {
    START_NEW_PROCESS = "START_NEW_PROCESS",
    SEE_PROCESS_STATUS = "SEE_PROCESS_STATUS",
    SEE_COMPLETED_PROCESS_STATUS = "SEE_COMPLETED_PROCESS_STATUS",
    SEE_EXPIRED_PROCESS_STATUS = "SEE_EXPIRED_PROCESS_STATUS",
    GO_TO_KYC = "GO_TO_KYC",
    GIVE_CONSENT = "GIVE_CONSENT",
}

export enum ProcessStatus {
    WAITING_FOR_APPROVER_PARENT_CONSENT = "WAITING_FOR_APPROVER_PARENT_CONSENT",
    PENDING_KYC_CONSENT = "PENDING_KYC_CONSENT",
    PENDING_KYC_ADVISOR_REVIEW = "PENDING_KYC_ADVISOR_REVIEW",
    COMPLETED = "COMPLETED",
    EXPIRED = "EXPIRED",
    UNKNOWN = "UNKNOWN",
}

export enum SparingApplication {
    SMARTSPAR = "SMARTSPAR",
    MSS = "MSS",
    MOBILBANK_OLD = "MOBILBANK_OLD",
    MOBILBANK = "MOBILBANK",
    NETTBANK = "NETTBANK",
    EIT = "EIT",
    PENSJONSMENTOR = "PENSJONSMENTOR",
    RPLUSS = "RPLUSS",
    SPAREADMIN = "SPAREADMIN",
    UNKNOWN = "UNKNOWN",
}
